const ExperienceList = [
  {
    Name: "Code Squad 3.0 - Inter University Programming Competition",
    Position: "Chairperson",
    StartYear: "Aug 2022",
    EndYear: "Feb 2023",
  },
  {
    Name: "Department of computer Engineering, Faculty of Engineering, USJ",
    Position: "18/19 Batch - Student Representative",
    StartYear: "Feb 2021",
    EndYear: "Present",
  },
  {
    Name: "C E N S O C - Computer Engineering Society of FOE USJ",
    Position: "Vice President ",
    StartYear: "Nov 2022",
    EndYear: "Nov 2023",
  },
  {
    Name: "Rotaract Club of University of Sri Jayewardenepura",
    Position: "Co Director Public Relations",
    StartYear: "July 2021",
    EndYear: "July 2022",
  },
  {
    Name: "C E N S O C - Computer Engineering Society of FOE US",
    Position: "Committee Member ",
    StartYear: "Apr 2022",
    EndYear: "Nov 2022",
  },
  {
    Name: "Rotaract Club of University of Sri Jayewardenepura",
    Position: "Committee Member - Community Service",
    StartYear: "Nov 2020",
    EndYear: "July 2021",
  },
  {
    Name: "IEEE Student Branch - University of Sri Jayewardenepura",
    Position: "Public Relations Committee ",
    StartYear: "Oct 2021",
    EndYear: "Oct 2022",
  },
  {
    Name: "Computer Society of Sri Lanka Genz Chapter of USJ",
    Position: "Assistant Secretary (Publicity) ",
    StartYear: "Mar 2023",
    EndYear: "present",
  },
  {
    Name: "People's Bank Sri Lanka",
    Position: "Temporary Office Assistant",
    StartYear: "Jan 2019",
    EndYear: "Dec 2019",
  },
  {
    Name: "Science Society - Bandaranayake College Gampaha",
    Position: "Treasurer",
    StartYear: "Apr 2017",
    EndYear: "Apr 2018",
  },
];
const ExperienceData = {ExperienceList};
export default ExperienceData;
